import React from 'react';

import FrameDetailsList from 'features/Frames/components/FrameDetailsList/FrameDetailsList';
import FrameDetailsTitle from 'features/Frames/components/FrameDetailsTitle/FrameDetailsTitle';
import FrameStatusCard from 'features/Frames/components/FrameStatusCard';
import { Frame } from 'features/Frames/types';

import useStyles from './FrameDetails.styles';

type FrameDetailsProps = {
  currentFrame: Frame;
};

const FrameDetails = ({ currentFrame }: FrameDetailsProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <FrameDetailsTitle currentFrame={currentFrame} />
        <FrameDetailsList currentFrame={currentFrame} />
      </div>
      <FrameStatusCard currentFrame={currentFrame} />
    </div>
  );
};

export default FrameDetails;
